<template>
  <div class="saved-filters">
    <section-separator v-if="showSeparator">
      {{$t('filterPresets.title')}}
    </section-separator>

    <router-link
      v-for="(preset, index) in filterList"
      :key="index"
      :to="{name: getRouteName(routeTypes.LIST, entity), query: { filter: preset.name }}"
      v-slot="{href}">
      <a class="nav-list__item cursor-pointer d-flex justify-content-between"
         :class="{ active: activeFilterIndex === index }"
         @click.stop="setActivePreset(preset, index)"
         :href="href">
        <div>
          {{preset.name}}
        </div>
        <base-button v-if="activeFilterIndex === index && !preset.persistent"
                     @click="deleteFilter(preset)"
                     outline
                     icon
                     size="sm"
                     type="danger">
          <i class="far fa-trash-alt"></i>
        </base-button>
      </a>
    </router-link>
    <div v-if="shouldShowMoreFiltersText" class="ml-2 text-primary cursor-pointer mt-4" @click="toggleShowMoreFilters">
      {{filtersLimit === jobBoards.length ? $t('filters.showLess') : $t('filters.showMore')}}
    </div>
  </div>
</template>
<script>
  import { getRouteName, routeTypes } from 'src/config/routeTypes'

  export default {
    name: 'saved-filters',
    props: {
      entity: String,
      showSeparator: Boolean
    },
    data () {
      return {
        activeFilterIndex: -1,
        routeTypes,
        filtersLimit: 3,
        defaultFiltersLimit: 3,
      }
    },
    computed: {
      filterList () {
        const defaultFilters = this.$store.state.filterPresets.filterPresets.filter(p => p.entity === this.entity)
        return defaultFilters.concat(this.jobBoardFilters)
      },
      jobBoards () {
        return this.$store.state.config.jobBoards
      },
      shouldShowMoreFiltersText() {
        return this.jobBoards.length >= this.filtersLimit
      },
      jobBoardFilters () {
        const mappedFilters = this.jobBoards.map(jobBoard => {
          return {
            entity: this.entity,
            name: jobBoard.name,
            persistent: true,
            filters: [
              {
                label: 'Job Board',
                operator: 'IN',
                values: [jobBoard.id],
                valuesLabel: jobBoard.name,
                field: {
                  field: 'job_board_id',
                  label: 'Job Board',
                  type: 'string'
                }
              }
            ]
          }
        })
        return mappedFilters.slice(0, this.filtersLimit)
      }
    },
    methods: {
      getRouteName,
      setActivePreset (preset, index) {
        this.activeFilterIndex = index
        this.$store.commit('filters/SET_ACTIVE_FILTERS', preset.filters)
      },
      deleteFilter (preset) {
        this.$store.commit('filterPresets/REMOVE_FILTER_PRESET', preset)
      },
      toggleShowMoreFilters () {
        if (this.filtersLimit < this.jobBoards.length) {
          this.filtersLimit = this.jobBoards.length
        } else {
          this.filtersLimit = this.defaultFiltersLimit
        }
      }
    },
    mounted () {
      this.$store.commit('filterPresets/PATCH_DEFAULT_FILTERS')
      let filterName = this.$route.query.filter
      let preset = this.filterList.find(p => p.name === filterName)
      let presetIndex = this.filterList.findIndex(p => p.name === filterName)
      if (preset) {
        this.$store.commit('filters/SET_ACTIVE_FILTERS', preset.filters)
        this.activeFilterIndex = presetIndex
      }
    },
    watch: {
      '$route.name'(newName, oldName) {
        if (!newName.includes('order')) {
          this.activeFilterIndex = -1
        }
      }
    }
  }
</script>
